export default {
  updateSku() {
    this.buildSkuData()
    this.updateSubmission()
  },
  buildSkuData() {
    const newPackageData = [...this.familyPackData, ...this.singleStyleData]
    this.$store.commit('submissions/buildSkuData', newPackageData)
  },
  setData() {
    this.singleStyleData = this.submissionPackages.filter(pack => pack.packageType === 'singleStyle')
    this.familyPackData = this.submissionPackages.filter(pack => pack.packageType === 'familyPackage')
    if (this.submissionPackages.length !== 0 && this.submissionPackages[0].packageType === 'familyPackage') {
      this.isSkuAvailable = true
    } else {
      this.isSkuAvailable = false
    }
    this.singleStyleData.map(() => this.isSingleSkuAvailable.push(true))
    if (this.singleStyleData.length === 0) {
      this.isSingleSkuAvailable = []
    }
  },
  removeSingleStyleSku(key) {
    this.singleStyleData.splice(key, 1)
  },
  showSkuLabel (data) {
    return (this.getUserRoles(this.user) === 'foundrySupport') && data.externalSku !== '' && data.hasOwnProperty('externalSku')
  }
}
